<template>
    <section>
      <div class="mdl-grid center-items">
        <div class="mdl-cell mdl-cell--12-col center-items">
          <h4>Create New League</h4>
          <form id="create-league-form" v-on:submit.prevent="createLeague">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
              <input class="mdl-textfield__input" type="text" id="leagueNameCreate" autocomplete="off" v-model="leagueInfo.leagueName" required>
              <label class="mdl-textfield__label" for="leagueNameCreate">New League Name</label>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
              <input class="mdl-textfield__input" type="text" id="passcodeCreate" autocomplete="off" v-model="leagueInfo.leagueSecret" required>
              <label class="mdl-textfield__label" for="passcodeCreate">New League Secret</label>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
              <input class="mdl-textfield__input" type="text" id="createTeamName" autocomplete="off" v-model="leagueInfo.teamName" required>
              <label class="mdl-textfield__label" for="createTeamName">New Team Name</label>
            </div>
            <div>
              <button id="submitJoin" type="submit" class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                Create League
              </button>
            </div> 
          </form> 
        </div>
      </div>      
    </section>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      user: null,
      leagueInfo: {
        leagueUID: "create",
        leagueName: "",
        leagueSecret: "",
        teamName: ""
      },
      
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
            this.user = user;
        }
    });
  },
  methods: {
    createLeague: async function() {
        // console.log("Want to create league "+this.leagueInfo.leagueName+" with passcode "+this.leagueInfo.leagueSecret+" with team name "+this.leagueInfo.teamName)
        firebase.database().ref('/users/'+this.user.uid+'/leagues/').push(this.leagueInfo)
        location.reload();
    }
  }
}

</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/CreateLeague.vue